module.exports = __webpack_public_path__ + "static/media/brunette.84db2e1b.png";